import { useSuspenseQuery } from "@tanstack/react-query"
import {
  createQueryKey,
  FUNDRAISING_ADVISORY_BASE_KEY,
} from "@/api/query-keys.ts"
import {
  GetVcMatchesOptionsRequest,
  GetVcMatchesResponse,
} from "@/feature/fundraising-advisory/vc-matching/api/types.ts"
import { axiosInstance } from "@/api/axios.ts"

const createVcMatchesQueryKey = (request: GetVcMatchesOptionsRequest) =>
  createQueryKey({
    baseKey: FUNDRAISING_ADVISORY_BASE_KEY,
    keys: [`vcMatching`, `perPage_${request.perPage}`, `page_${request.page}`],
  })

export const getVcMatches = async (
  request: GetVcMatchesOptionsRequest
): Promise<GetVcMatchesResponse> =>
  (
    await axiosInstance.get<GetVcMatchesResponse>(`/fundraising/vc-matching`, {
      params: request,
    })
  ).data

export const getVcMatchesQuery = (request: GetVcMatchesOptionsRequest) => ({
  queryKey: createVcMatchesQueryKey(request),
  queryFn: () => getVcMatches(request),
})

export const useGetVcMatches = (request: GetVcMatchesOptionsRequest) =>
  useSuspenseQuery(getVcMatchesQuery(request))
